import { useMemo } from 'react';
import { Users, User, GraduationCap } from 'lucide-react';

const RecipientSelector = ({
  value = 'parent',
  onChange,
  label = 'Target Audience',
  helperText = '',
  disabled = false,
  className = '',
  stepNumber = null,
  size = 'md',
  icon: HeaderIcon = Users
}) => {
  const options = useMemo(() => {
    const allOptions = [
      {
        value: 'parent',
        label: 'Parents',
        icon: User,
      },
      {
        value: 'student',
        label: 'Students',
        icon: GraduationCap,
      },
      {
        value: 'both',
        label: 'Both',
        icon: Users,
      }
    ];

    const orgType = localStorage.getItem('organizationType')?.toUpperCase();
    
    // For Schools (default behavior), we only show Parents option
    // For Colleges, we show all options (Parents, Students, Both)
    if (orgType === 'COLLEGE') {
      return allOptions;
    }

    return allOptions.filter(opt => opt.value === 'parent');
  }, []);

  return (
    <div className={`w-full ${className}`}>
      {label && (
        <div className="mb-3">
          <h3 className="text-xs font-medium text-gray-500 uppercase">
            {stepNumber ? `${stepNumber}. ` : ''}{label}
          </h3>
          {helperText && (
            <p className="text-xs text-gray-400 mt-1">
              {helperText}
            </p>
          )}
        </div>
      )}
      
      <div className={`grid grid-cols-3 gap-3 ${size === 'sm' ? 'w-full' : 'max-w-2xl'}`}>
        {options.map((option) => {
          const Icon = option.icon;
          const isSelected = value === option.value;
          
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => !disabled && onChange(option.value)}
              disabled={disabled}
              className={`
                flex flex-col items-center justify-center gap-1.5 py-3 px-2 rounded-md border transition-all
                ${isSelected 
                  ? 'text-white' 
                  : 'border-gray-300 bg-white text-gray-600 hover:border-gray-400 hover:bg-gray-50'
                }
                ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
              `}
              style={isSelected ? { 
                backgroundColor: 'var(--primary-color)', 
                borderColor: 'var(--primary-color)' 
              } : {}}
            >
              <Icon size={16} strokeWidth={2} />
              <div className="text-xs font-medium">
                {option.label}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default RecipientSelector;
